import { z } from 'zod';

/** Gli elenchi che si possono esportare. */
export const DatasetExport = z.enum(['clienti', 'partner', 'progetti', 'task', 'utenti']);
export type DatasetExport = z.infer<typeof DatasetExport>;

export const FormatoExport = z.enum(['xlsx', 'csv']);
export type FormatoExport = z.infer<typeof FormatoExport>;

/** Ciclo di vita di un export avanzato, dalla richiesta alla scadenza del file. */
export const StatoEsportazione = z.enum(['in_coda', 'in_corso', 'pronto', 'fallito', 'scaduto']);
export type StatoEsportazione = z.infer<typeof StatoEsportazione>;
